import React from 'react';

export const TabElement = props => (
  <li className={`tabs-item ${props.isActive ? 'active' : null}`} >
    <a data-permisos={`${props.entity.permisos}`} className='tabs-item-link' onClick={() => props.selectTab(props.index)}>{props.entity.name}</a>
  </li>
);

const elements = [
                  {name:'Proformas',permisos:'ind_tab_proformas'},
                  {name:'Historial FDV',permisos:'ind_tab_historial_fdv'},
                  {name:'Adjuntos',permisos:'ind_tab_adjuntos'},
                  {name:'Excepciones',permisos:'ind_tab_excepciones'},
                  {name: 'Facturación',permisos:'ind_tab_facturacion'},
                  {name: 'Equipos logística',permisos:'ind_tab_equipos_logistica'},
                  {name:'Bonos', permisos:'ind_tab_bonos'},
                  {name: 'Observaciones',permisos:'ind_tab_observaciones'},
                  {name:'Accesos directos',permisos:'ind_tab_accesos_directos'}];

const Tabs = props => (
  <div className='fdv-tab-container'>
    <div className='fdv-tabs wrapper'>
      <div className='tabs-container'>
        <button className='tabs-left'>
          <i className='ion-chevron-left' />
        </button>
        <div className='tabs-wrapper'>
          <ul className='tabs' role='tablist'>
            {props.elements.map((element, index) => (
              <TabElement
                key={index}
                entity={element}
                index={index}
                isActive={index === props.tabSeleccionado}
                selectTab={props.selectTab}
              />
            ))}
          </ul>
        </div>
        <button className='tabs-right'><i className='ion-chevron-right' /></button>
      </div>
      <a className='btn btn-blue btn-sm fdv-tabs-ac' index={8} onClick={() => props.selectTab(8)}>
        Accesos directos
      </a>
    </div>
  </div>
);

Tabs.defaultProps = {
  elements,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/Tabs.js